<template>
  <div class="audit-pending-container">
    <!-- 背景图模糊层 -->
    <div class="bg-layer"></div>

    <!-- 审核中卡片 -->
    <div class="audit-pending-card">
      <!-- 返回 -->
      <button type="button" class="back-btn" @click="handleBack">
        <svg viewBox="0 0 24 24" width="20" height="20">
          <path
            d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
            fill="currentColor"
          />
        </svg>
        返回
      </button>

      <!-- 审核中图标 -->
      <div class="pending-icon">
        <div class="icon-circle">
          <svg viewBox="0 0 24 24" width="64" height="64">
            <path
              d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-13h-2v6l5.25 3.15L17 12.23l-4-2.37V7z"
              fill="currentColor"
            />
          </svg>
        </div>
        <div class="loading-ring">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <div class="pending-line"></div>
      </div>

      <!-- 标题 -->
      <div class="audit-header">
        <h1 class="title">审核中</h1>
        <p class="subtitle">您的认证资料正在审核中，请耐心等待</p>
      </div>

      <!-- 进度信息 -->
      <div class="progress-section">
        <div class="progress-steps">
          <div class="step active">
            <div class="step-dot"></div>
            <span class="step-label">提交资料</span>
          </div>
          <div class="step-line"></div>
          <div class="step active">
            <div class="step-dot"></div>
            <span class="step-label">审核中</span>
          </div>
          <div class="step-line"></div>
          <div class="step">
            <div class="step-dot"></div>
            <span class="step-label">完成</span>
          </div>
        </div>
        <div class="progress-bar">
          <div class="progress-fill" :style="{ width: progress + '%' }"></div>
        </div>
      </div>

      <!-- 用户信息 -->
      <!-- <div class="user-info-card">
        <div class="info-row">
          <span class="info-label">👤 真实姓名</span>
          <span class="info-value">{{ userInfo.realName || '张三' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">📧 邮箱</span>
          <span class="info-value">{{ userInfo.email || 'zhangsan@example.com' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">📱 手机号码</span>
          <span class="info-value">{{ userInfo.phone || '138****1234' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">🆔 身份证号</span>
          <span class="info-value">{{ userInfo.idNumber || '440***********001X' }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">📅 提交时间</span>
          <span class="info-value">{{ userInfo.submitTime || '2024-01-15 14:30:00' }}</span>
        </div>
      </div> -->

      <!-- 温馨提示 -->
      <div class="tips-section">
        <div class="tip-item">
          <span class="tip-icon">⏰</span>
          <span class="tip-text">预计审核时间：{{ estimateTime || '24小时内' }}</span>
        </div>
        <div class="tip-item">
          <span class="tip-icon">📧</span>
          <span class="tip-text">审核结果将通过邮件通知您</span>
        </div>
        <div class="tip-item">
          <span class="tip-icon">💡</span>
          <span class="tip-text">请保持手机畅通，以便接收通知</span>
        </div>
      </div>

      <!-- 操作按钮 -->
      <!-- <div class="audit-actions">
        <button class="action-btn primary" @click="handleConfirm">
          我知道了
        </button>
        <button class="action-btn secondary" @click="handleBack">
          返回首页
        </button>
      </div> -->

      <!-- 底部 -->
      <!-- <div class="audit-footer">
        <p>如有疑问，请联系技术支持</p>
        <a href="#" class="contact-link" @click.prevent="handleContact">
          support@example.com
        </a>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: "AuditPendingPage",
  data() {
    return {
      progress: 50,
      estimateTime: "24小时内",
      userInfo: {
        realName: "张三",
        email: "zhangsan@example.com",
        phone: "138****1234",
        idNumber: "440***********001X",
        submitTime: "2024-01-15 14:30:00",
      },
    };
  },
  created() {
    // 从路由参数或接口获取用户信息
    // this.fetchUserInfo();
    // 模拟进度更新
    this.simulateProgress();
  },
  beforeUnmount() {
    if (this.progressTimer) {
      clearInterval(this.progressTimer);
    }
  },
  methods: {
    handleBack() {
      this.$router.push({ name: "Home" });
    },
    handleConfirm() {
      this.$router.push({ name: "Home" });
    },
    handleContact() {
      window.location.href = "mailto:support@example.com";
    },
    simulateProgress() {
      const steps = [10, 25, 40, 55, 70, 85, 95];
      let index = 0;
      this.progressTimer = setInterval(() => {
        this.progress = steps[index];
        index++;
        if (index >= steps.length) {
          clearInterval(this.progressTimer);
        }
      }, 500);
    },
    async fetchUserInfo() {
      try {
        // const res = await this.$api.user.getAuditInfo();
        // this.userInfo = res.data;
      } catch (error) {
        console.error("获取用户信息失败:", error);
      }
    },
  },
};
</script>

<style scoped>
/* ===== 容器 ===== */
.audit-pending-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 20px;
}

/* ===== 背景图层 ===== */
.bg-layer {
  position: absolute;
  inset: 0;
  background-image: url("@/assets/imgs/dlbj.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  transform: scale(1.05);
  z-index: 0;
}

/* ===== 审核中卡片 ===== */
.audit-pending-card {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 520px;
  padding: 40px 44px 32px;
  background: rgba(255, 255, 255, 0.06);
  backdrop-filter: blur(24px) saturate(180%);
  -webkit-backdrop-filter: blur(24px) saturate(180%);
  border-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.5),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  text-align: center;
  transition: all 0.3s ease;
}

.audit-pending-card:hover {
  border-color: rgba(100, 200, 255, 0.2);
  box-shadow: 0 30px 80px rgba(0, 0, 0, 0.6), 0 0 60px rgba(0, 150, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.15);
}

/* ===== 返回按钮 ===== */
.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.4);
  font-size: 14px;
  cursor: pointer;
  padding: 4px 0;
  transition: all 0.3s ease;
  font-family: inherit;
  margin-bottom: 16px;
}

.back-btn:hover {
  color: #00b4ff;
  transform: translateX(-4px);
}

/* ===== 审核中图标 ===== */
.pending-icon {
  margin: 8px 0 16px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.icon-circle {
  width: 96px;
  height: 96px;
  margin: 0 auto;
  background: linear-gradient(135deg, rgba(255, 193, 7, 0.15), rgba(255, 152, 0, 0.05));
  border: 3px solid rgba(255, 193, 7, 0.3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
}

.icon-circle svg {
  color: #ffc107;
  animation: rotate-icon 3s linear infinite;
}

@keyframes rotate-icon {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 加载环 */
.loading-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 116px;
  height: 116px;
}

.loading-ring span {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 3px solid transparent;
  border-top-color: #ffc107;
  animation: spin-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.loading-ring span:nth-child(2) {
  animation-delay: -0.4s;
  border-top-color: #ff9800;
}

.loading-ring span:nth-child(3) {
  animation-delay: -0.8s;
  border-top-color: #ff5722;
}

@keyframes spin-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.pending-line {
  width: 60px;
  height: 2px;
  margin: 12px auto 0;
  background: linear-gradient(90deg, transparent, rgba(255, 193, 7, 0.3), transparent);
}

/* ===== 标题 ===== */
.audit-header {
  margin-bottom: 24px;
}

.title {
  font-size: 28px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px;
  letter-spacing: 1px;
  text-shadow: 0 2px 20px rgba(0, 0, 0, 0.3);
}

.subtitle {
  font-size: 14px;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.5);
  margin: 0;
}

/* ===== 进度条 ===== */
.progress-section {
  margin-bottom: 24px;
}

.progress-steps {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.step-dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease;
}

.step.active .step-dot {
  background: #ffc107;
  border-color: #ffc107;
  box-shadow: 0 0 20px rgba(255, 193, 7, 0.3);
}

.step-label {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.3);
  white-space: nowrap;
}

.step.active .step-label {
  color: rgba(255, 255, 255, 0.7);
}

.step-line {
  width: 40px;
  height: 2px;
  background: rgba(255, 255, 255, 0.08);
  margin: 0 4px;
  margin-bottom: 16px;
}

.progress-bar {
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.08);
  border-radius: 2px;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  background: linear-gradient(90deg, #ffc107, #ff9800, #ff5722);
  border-radius: 2px;
  transition: width 0.8s ease;
}

/* ===== 用户信息卡片 ===== */
.user-info-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 16px;
  text-align: left;
}

.info-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.04);
}

.info-row:last-child {
  border-bottom: none;
}

.info-label {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.4);
  font-weight: 400;
}

.info-value {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  font-weight: 500;
}

/* ===== 温馨提示 ===== */
.tips-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 18px;
  background: rgba(255, 193, 7, 0.06);
  border: 1px solid rgba(255, 193, 7, 0.1);
  border-radius: 10px;
  margin-bottom: 24px;
  text-align: left;
}

.tip-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.tip-icon {
  font-size: 16px;
  flex-shrink: 0;
}

.tip-text {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
}

/* ===== 操作按钮 ===== */
.audit-actions {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.action-btn {
  flex: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 11px 20px;
  border: none;
  border-radius: 10px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: inherit;
}

.action-btn.primary {
  background: linear-gradient(135deg, #ffc107, #ff9800);
  color: #fff;
  box-shadow: 0 4px 20px rgba(255, 193, 7, 0.25);
}

.action-btn.primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(255, 193, 7, 0.35);
}

.action-btn.primary:active {
  transform: translateY(0);
}

.action-btn.secondary {
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.action-btn.secondary:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #fff;
  transform: translateY(-2px);
}

.action-btn.secondary:active {
  transform: translateY(0);
}

/* ===== 底部 ===== */
.audit-footer {
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.audit-footer p {
  color: rgba(255, 255, 255, 0.3);
  font-size: 13px;
  margin: 0 0 4px;
}

.contact-link {
  color: #00b4ff;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.3s;
}

.contact-link:hover {
  color: #66ccff;
  text-decoration: underline;
}

/* ===== 响应式适配 ===== */
@media (max-width: 520px) {
  .audit-pending-card {
    padding: 28px 20px 24px;
    border-radius: 16px;
    margin: 12px;
  }

  .title {
    font-size: 22px;
  }

  .subtitle {
    font-size: 13px;
  }

  .icon-circle {
    width: 72px;
    height: 72px;
  }

  .icon-circle svg {
    width: 48px;
    height: 48px;
  }

  .loading-ring {
    width: 92px;
    height: 92px;
  }

  .step-line {
    width: 20px;
  }

  .step-label {
    font-size: 10px;
  }

  .audit-actions {
    flex-direction: column;
    gap: 10px;
  }

  .action-btn {
    padding: 12px 16px;
  }

  .info-row {
    flex-direction: column;
    gap: 2px;
    padding: 6px 0;
  }

  .info-label {
    font-size: 12px;
  }

  .info-value {
    font-size: 13px;
  }

  .bg-layer {
    filter: blur(8px) brightness(0.6);
    -webkit-filter: blur(8px) brightness(0.6);
  }
}

@media (max-width: 380px) {
  .audit-pending-card {
    padding: 20px 14px 18px;
  }

  .title {
    font-size: 19px;
  }

  .icon-circle {
    width: 60px;
    height: 60px;
  }

  .icon-circle svg {
    width: 36px;
    height: 36px;
  }

  .loading-ring {
    width: 80px;
    height: 80px;
  }

  .tips-section {
    padding: 10px 12px;
  }

  .tip-text {
    font-size: 12px;
  }
}
</style>